// React Imports
import React, { useEffect, useRef, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { baseUrl } from "../../helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
} from "@fluentui/react-components";
import {
  ArrowUpload24Filled,
  DismissSquare24Regular,
} from "@fluentui/react-icons";

// Props
interface IAddAcademyUserCertificateDialogProps {
  academyDocumentFolderGuid: string;
  appUserGuid: string;
  isDialogOpen: boolean;
  onDismiss: any;
}

// Function
function AddAcademyUserCertificateDialog(
  props: IAddAcademyUserCertificateDialogProps,
) {
  const inputFile = useRef<any>(null);

  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);

  const onSelectedFile = (event: any) => {
    if (event.target.files.length == 1) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const uploadFile = () => {
    if (selectedFile != undefined) {
      var data = new FormData();
      data.append("file", selectedFile);
      fetchWrapper
        .sendFilesWithAuth(
          `${baseUrl}/api/Academy/UploadCertificate?academyDocumentFolderGuid=${props.academyDocumentFolderGuid}&appUserGuid=${props.appUserGuid}`,
          data,
        )
        .then((result) => {
          props.onDismiss();
        });
    }
  };

  return (
    <div>
      {/* <Dialog
      
      >
        <Stack tokens={{ childrenGap: 10 }}>
          <Stack horizontal tokens={{ childrenGap: 5 }} grow>
            <Stack.Item grow={1}>
              <TextField
                required
                readOnly
                label={i18n.t<string>("file")}
                value={selectedFile?.name}
              />
            </Stack.Item>

            <input
              disabled={!props.isDialogOpen}
              type="file"
              id="file"
              accept=".pdf"
              ref={inputFile}
              style={{ display: "none" }}
              onChange={onSelectedFile}
            />

            <IconButton
              style={{ marginTop: 34 }}
              iconProps={{ iconName: "Upload" }}
              onClick={() =>
                inputFile ? inputFile.current.click() : undefined
              }
            />
          </Stack>
        </Stack>
        <DialogFooter>
          <PrimaryButton
            iconProps={{ iconName: "Upload" }}
            disabled={!selectedFile}
            onClick={() => {
              uploadFile();
            }}
            text={i18n.t<string>("uploadFile")}
          />
          <DefaultButton
            iconProps={{ iconName: "Cancel" }}
            onClick={() => props.onDismiss()}
            text={i18n.t<string>("cancel")}
          />
        </DialogFooter>
      </Dialog> */}
      <Dialog open={props.isDialogOpen} onOpenChange={() => props.onDismiss()}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{i18n.t<string>("uploadFile")}</DialogTitle>
            <DialogContent>
              {i18n.t<string>("uploadFileText")}
              <div>
                <input
                  disabled={!props.isDialogOpen}
                  type="file"
                  id="file"
                  accept=".pdf"
                  ref={inputFile}
                  style={{ display: "none" }}
                  onChange={onSelectedFile}
                />
                {/* <Field
                  required
                  readOnly
                  label={i18n.t<string>("file")}
                  value={selectedFile?.name}
                /> */}
                <Button
                  style={{ marginTop: 34 }}
                  icon={<ArrowUpload24Filled />}
                  onClick={() =>
                    inputFile ? inputFile.current.click() : undefined
                  }
                >
                  {i18n.t<string>("file")}
                </Button>
                {selectedFile?.name && <div>{selectedFile?.name}</div>}
              </div>
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button
                  icon={<DismissSquare24Regular />}
                  onClick={() => {
                    props.onDismiss();
                  }}
                  appearance="secondary"
                >
                  {i18n.t<string>("cancel")}
                </Button>
              </DialogTrigger>
              <Button
                disabled={!selectedFile}
                onClick={() => {
                  uploadFile();
                }}
                appearance="primary"
              >
                {i18n.t<string>("uploadFile")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

// Export Function
export default AddAcademyUserCertificateDialog;
